<template>
    <div :class="{'day_percent_bar':true, 'mod--sunday':sunday, 'today':today}" draggable="false">
        <div class="elm_label">
            <div class="elm_percentage">{{ percentage }} %</div>
        </div>
        <div class="elm_bar">
            <div class="elm_inner" :style="{height: percentage + '%'}"/>
        </div>
        <div class="elm_label">
            <div class="elm_day">{{ dayAbbr }}</div>
            <div class="elm_date">{{ dayNum }}</div>
        </div>
        <!--<div class="elm_today" v-if="today"/>-->
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'day-percent-bar',
    props: ['percentage', 'date'],

    computed: {
        dayAbbr: function () {
            return moment(this.date).format('ddd')
        },
        dayNum: function () {
            return moment(this.date).format('DD')
        },
        today:function (){
            return moment(this.date).isSame(new Date(), 'day')
        },
        sunday:function(){
            return moment(this.date).day() === 0
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/part/item/day_percent_bar.vue